import { render, staticRenderFns } from "./SettingsUsers.vue?vue&type=template&id=596d376a&scoped=true"
import script from "./SettingsUsers.vue?vue&type=script&lang=js"
export * from "./SettingsUsers.vue?vue&type=script&lang=js"
import style0 from "./SettingsUsers.vue?vue&type=style&index=0&id=596d376a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596d376a",
  null
  
)

export default component.exports